import React from 'react';
import { useIntl } from 'react-intl';
import { TypedMemo } from '../../common/types';
import { SMLButton } from '../../common/views/SMLButton/SMLButton';
import type { CoverPublicTool } from '../CoverEditorContext';
import { publicCoverMessages } from './publicCoverMessages';
import { withBrandWord } from '../../music24/components/primitives/BrandWord';
/* eslint-disable css-modules/no-unused-class -- one stylesheet for the cover editor; each part uses its own slice of it */
import editorStyles from '../CoverEditor.module.scss';
import styles from './PublicCoverMaker.module.scss';
/* eslint-enable css-modules/no-unused-class */

interface AiPublicUpsellProps {
  tool: CoverPublicTool;
  onOpenBank: () => void;
}

/**
 * The AI tab of the public tool (owner decisions D6, D11; design cover-editor g2): no AI call can
 * start here. The card says what a paid plan gives, with the way to the plans and to a free
 * account, and what is free in this tool. The page shows no price: the plan table owns the prices.
 */
const AiPublicUpsellComponent: React.FC<AiPublicUpsellProps> = ({ tool, onOpenBank }) => {
  const intl = useIntl();
  return (
    <>
      <div className={editorStyles.lock}>
        <span className={styles.eyebrow}>{intl.formatMessage(publicCoverMessages.aiEyebrow)}</span>
        <b>{intl.formatMessage(publicCoverMessages.aiTitle)}</b>
        <p>{intl.formatMessage(publicCoverMessages.aiText)}</p>
        <a
          className={styles.primaryLink}
          href={tool.plansHref}
          target={tool.isEmbed ? '_top' : '_blank'}
          rel="noopener noreferrer"
        >
          {intl.formatMessage(publicCoverMessages.aiPlans)}
        </a>
        <button type="button" className={editorStyles.linkButton} onClick={tool.onSignUp}>
          {intl.formatMessage(publicCoverMessages.aiSignUp)}
        </button>
      </div>
      <div className={styles.freeBox}>
        <b>{intl.formatMessage(publicCoverMessages.aiFree)}</b>
        <p>{withBrandWord(intl.formatMessage(publicCoverMessages.aiFreeText))}</p>
        <SMLButton size="sm" outline omitCap onClick={onOpenBank}>
          {intl.formatMessage(publicCoverMessages.aiOpenBank)}
        </SMLButton>
      </div>
    </>
  );
};

export const AiPublicUpsell = TypedMemo(AiPublicUpsellComponent);
